<template lang="html">
  <div class="text-left" >
    <Header />
    <SideBar />
    <!-- Start Wrapper Main Section -->
    <section class="wrapper__main" id="wrapper__main">
      <!-- Start Nurses Section -->
      <div class="content">
        <div class="row">
          <div class="col-sm-4 col-3">
            <h4 class="page-title">Merchants</h4>
          </div>
          <div class="col-sm-8 col-9 text-right m-b-20">
            <router-link to="add-nurse" class="btn btn-primary  d-none btn-rounded float-right"><i class="fa fa-plus"></i> Add nurse</router-link>
          </div>
        </div>
        
        <div class="row nurse-grid">
          <!-- nurse component   -->
          <Nurse v-for="nurse in nurses" :key="nurse.id" :nurse="nurse" @deleteNurse="delNurse" />
          <div class="col-md-12">
            <div class="more-btn">
              <a class="see-more-btn" href="#!">Load More</a>
            </div>
          </div>
        </div>
      </div>
      <!-- End Nurses Section -->
    </section>
    <!-- End Wrapper Main Section -->
  </div>
  <!-- End Wrapper Page Section -->
</template>

<script>
import Loading from '@/components/assets/Loading';
import Nurse from '@/components/Nurse.vue';

export default {
  components:{
    Loading,
    Nurse
  },
  computed:{
    api(){
      return this.$store.state.api;
    }
  },
  data(){
    return{
      nurses: []
    }
  },
  mounted(){
    fetch(`${this.api}/admin/nurse`,
    {
      headers:{
        "Authorization": localStorage.getItem('care_auth_token') || null
      }
    })
    .then(res => res.json())
    .then(data=>{
      if(data.success){
        this.nurses = data.data;
      }
    })
  },
  methods:{
    delNurse(id){
      console.log(454545, id);
      this.nurses = this.nurses.filter(n => n.id != id)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
